module.exports = __webpack_public_path__ + "img/35.fc5b80a9.png";